import axios from 'axios';
import api, { portalRole } from './api';

export const swilEnabled = process.env.REACT_APP_SWIL_ENABLED === 'true';
const gateway = process.env.REACT_APP_SWIL_GATEWAY || '/swil-api/index.php';

export async function swilRequest(action, params = {}, options = {}) {
  if (!swilEnabled) {
    const error = new Error('S C Paul ERP services are not connected yet. Please check back later.');
    error.code = 'NOT_CONFIGURED';
    throw error;
  }
  try {
    const response = await axios({
      url: gateway, method: options.body ? 'POST' : 'GET',
      params: { action, ...params }, data: options.body, signal: options.signal,
      timeout: 120000, withCredentials: true,
      headers: { 'X-Portal-Role': portalRole, ...(options.body ? { 'X-Portal-Request': '1' } : {}) },
    });
    return response.data;
  } catch (error) {
    if (axios.isCancel(error)) throw error;
    const failure = new Error(error.response?.data?.error?.message || 'Unable to load ERP data. Please try again.');
    failure.code = error.response?.data?.error?.code || 'UNAVAILABLE';
    throw failure;
  }
}

export async function portalLogin(role, username, password) {
  const endpoint = role === 'salesman' ? 'salesman_login.php' : 'login.php';
  const response = await api.post(endpoint, { username, password });
  return response.data;
}

export async function portalLogout() {
  await api.post('logout.php', {});
}

export function displayValue(value) {
  return value === null || value === undefined || value === '' ? '—' : String(value);
}

export function money(value) {
  if (value === '' || value === null || value === undefined) return '—';
  const numeric = Number(String(value).replace(/,/g, ''));
  return Number.isFinite(numeric) ? new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(numeric) : '—';
}

export function csvText(rows) {
  if (!rows.length) return '';
  const keys = Array.from(new Set(rows.flatMap(row => Object.keys(row))));
  const quote = value => {
    const text = String(value ?? '');
    // Spreadsheet formula injection also applies to customer/product names.
    const safe = /^[\s]*[=+\-@\t\r]/.test(text) ? `'${text}` : text;
    return `"${safe.replace(/"/g, '""')}"`;
  };
  return '\uFEFF' + [keys, ...rows.map(row => keys.map(key => row[key]))].map(row => row.map(quote).join(',')).join('\r\n');
}

export function downloadCsv(rows, filename) {
  const url = URL.createObjectURL(new Blob([csvText(rows)], { type: 'text/csv;charset=utf-8;' }));
  const link = document.createElement('a');
  link.href = url; link.download = filename; link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
